export default __webpack_public_path__ + "static/media/Sweet-3.8d2277e4.jpg";